import { FC } from "react";

const NotFoud: FC = () => {     
    const ErrorIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-24 w-24 text-error dark:text-dark-error" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
        </svg>
    );

    return (
        <div className="min-h-screen bg-background dark:bg-dark-background flex flex-col items-center justify-center text-center p-6 transition-colors duration-300" role="alert" aria-live="assertive">
            <div className="max-w-md">
                <div className="flex justify-center mb-6">
                    <ErrorIcon />
                </div>
                <h1 className="text-3xl font-medium text-on-background dark:text-dark-on-background">Sitio No Encontrado</h1>
                <p className="mt-4 text-lg text-on-surface-variant dark:text-dark-on-surface-variant">
                    El sitio que estas buscando NO EXISTE.
                </p>                
            </div>
        </div>
    )
}  
export default NotFoud;